import React from "react";
import AdSenseUnit from "@/components/ads/AdSenseUnit";
import { AD_SLOTS } from "@/config/adSlots";
import { AD_LABEL } from "@/lib/adsensePolicy";

export default function ArticleLeaderboardAd({ className = "" }) {
  return (
    <aside aria-label={`${AD_LABEL} 728 by 90`} className={`flex justify-center overflow-hidden rounded-2xl border border-[#BFDADC] bg-white/92 p-3 shadow-[0_8px_20px_rgba(8,22,51,0.06)] ${className}`}>
      <div className="w-full max-w-[728px]">
        <div className="mb-2 text-center text-[11px] uppercase tracking-wide text-muted-foreground/70">{AD_LABEL}</div>
        <AdSenseUnit
          slot={AD_SLOTS.banner}
          format="auto"
          responsive={false}
          style={{ display: "block", width: 728, height: 90, minHeight: 90, maxWidth: "100%" }}
        />
      </div>
    </aside>
  );
}